import { render, staticRenderFns } from "./filters.vue?vue&type=template&id=b2a262be"
import script from "./filters.vue?vue&type=script&lang=ts"
export * from "./filters.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports